// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 872) return "static/chunks/e01b8c46-6aed6821c6315b58.js";
	if (chunkId === 960) return "static/chunks/960-baeae99f1a1d9ee5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 359 ? "f4052ef2" : chunkId) + "." + {"56":"385a8d323123b5e4","359":"43d9843cdc517dbc","907":"61df6391ef114358"}[chunkId] + ".js";
};